import { render } from "./UpdatePasswordPopup.vue?vue&type=template&id=186e2f66&scoped=true&ts=true"
import script from "./UpdatePasswordPopup.vue?vue&type=script&lang=ts"
export * from "./UpdatePasswordPopup.vue?vue&type=script&lang=ts"

import "./UpdatePasswordPopup.vue?vue&type=style&index=0&id=186e2f66&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186e2f66"]])

export default __exports__